export default "__VITE_ASSET__DLD44T7z__"